// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f6974993","198":"00cd90fe","643":"f105cdf1"}[chunkId] + ".chunk.js";
};